import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom';
import { Box, Hidden, IconButton, Typography } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu';
import { Container } from 'components'
import UserIcon from '../../../../components/Header/components/UserIcon'
import BusinessMobileMenu from '../MobileMenu'
import BusinessDropdownMenu from '../BusinessDropdownMenu'
import LogoSmallSrc from 'components/Logo/LogoSmall.png'
import {useIdleTimer} from "react-idle-timer";
import api from 'utils/api'

const BusinessHeader = ({
  children,
  title,
}) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [dropdownMenuAnchor, setDropdownMenuAnchor] = useState(null)
  const user = useSelector(state => state.user)

  useIdleTimer({
    timeout: 1000 * 60 * 35,
    onActive: () => {
      api.post('/geo', user.location).catch(() => {})
    },
    debounce: 500
  })

  return (<>
    <header>
      <Container>
        <Box py={3} display="flex" alignItems="center" justifyContent="space-between" height={48}>
          <Box display="flex" alignItems="center">
            <Hidden lgUp>
              <NavLink to="/">
                <img src={LogoSmallSrc} height={40} alt="HiddenUnderGround logo" style={{ marginRight: 10 }} />
              </NavLink>
            </Hidden>
            <Typography variant="h5">
              {title}
            </Typography>
            <Box display="flex" alignItems="center">
              {children}
            </Box>
          </Box>
          <Box>
            <Hidden lgUp>
              <IconButton
                aria-label="Open business navigation"
                onClick={() => setMobileMenuOpen(true)}
                style={{ marginRight: 8 }}
                size="large">
                <MenuIcon />
              </IconButton>
            </Hidden>
            <UserIcon
              avatar={user.details.imageUrl}
              name={user.details.firstName || user.details.email}
              handleClick={(e) => {
                setDropdownMenuAnchor(e.currentTarget)
              }}
            />
            <BusinessDropdownMenu anchorElement={dropdownMenuAnchor} onClose={() => setDropdownMenuAnchor(null)} />
          </Box>
        </Box>
      </Container>
    </header>
    <Hidden lgUp>
      <BusinessMobileMenu isOpen={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} businesses={user.businesses} />
    </Hidden>
  </>);
}

export default BusinessHeader
